import { Deserializer, makeQueryStringSerializer } from 'core/lib/serializer';
import apiFetch from './apiFetch';
import { API_URL } from './constants';
import * as Types from './definitions';

const baseUrl = (clientId: string, programId: string): string => {
    return `${API_URL}/api/v1/client/${clientId}/program/${programId}/Claim`;
};

const defaultRequest: Partial<Types.ClaimsSearchRequest> = {
    page: 1,
    sortIndex: 'submissionDate',
    sortDescending: true,
};
const serializer = makeQueryStringSerializer<Types.ClaimsSearchRequest>(defaultRequest, {
    page: Deserializer.Int,
    sortDescending: Deserializer.Bool,
});

export default class ClaimList {
    static defaultRequest = defaultRequest;

    static serializeRequest = serializer.serialize;

    static deserializeRequest = serializer.deserialize;

    static async search(
        clientId: string,
        programId: string,
        claimsSearchRequest: Partial<Types.ClaimsSearchRequest>,
    ): Promise<Types.SearchResultsResponse<Types.ClaimListItem>> {
        const query = ClaimList.serializeRequest(claimsSearchRequest, true);
        const response = await apiFetch(`${baseUrl(clientId, programId)}/list?${query}`);
        const claims: Types.SearchResultsResponse<Types.ClaimListItem> = await response.json();
        return claims;
    }
}
